export default __webpack_public_path__ + "static/media/handsomecoffeecatdraft_2595202ac6ca30678ec4d851bd9ccd4b.0d178920.png";